import Worker from '@wmfe/mach-pro-worker';
// // @ts-ignore
// import { uploadShoppingCartInfo } from '@/shared_worker_global/shop/index';
// // @ts-ignore
// import '@/shared_worker_global/market/index';
// // @ts-ignore
// import '@/shared_worker_global/traffichaven/index';
// // @ts-ignore
// import '@/shared_worker_global/preloadApi/index';
// // @ts-ignore
// import { startDataAnalysis } from '@/shared_worker_global/DataAnalysis/index';
import { uploadShoppingCartInfo } from './shop/index';
import './market/index';
import './traffichaven/index';
import './preloadApi/index';
import { startDataAnalysis } from './DataAnalysis/index';

const initWorker = () => {
  // 开始做分析
  startDataAnalysis();
  // work 与 native 通信
  Mach.sendEvent('worker_start_to_native', { msg: 'sharedworker启动成功' });

  // worker监听天降弹窗关闭消息
  Worker.on('fall_from_sky_popup_to_worker', (data: any) => {
    console.log('天降弹窗关闭===>', data);
  });

  // 购物车数据同步失败重试机制
  Worker.on('shop_cart_info_to_worker', (data: any) => {
    !!data.params && uploadShoppingCartInfo(data.params);
  });

  // 开始做分析
  startDataAnalysis();
};

export {
  initWorker,
};
